import { shelfBrackets } from '@/Constants/shelfBrackets';
import {
    moduleItem,
    railGroup,
    Shelf,
    sides,
    wardrobeItem,
    wardrobeModule,
    wardrobeTemplates,
    xyz,
} from '@/Interfaces/common';
import { useStoreData } from '@/Store/storeData';
import { rodHolder } from '@/Constants/rodHolder';
import { categoryDataApi, itemDataApi } from '@/Interfaces/api';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { rackHoles } from '@/Constants/common';
import { pullOutFrames } from '@/Constants/pullOutFrames';
import { rodCaps } from '@/Constants/rodCaps';
import { $ } from '@/Engine/state';
import { wallAccessories } from '@/Constants/accessories';
import { isRodAvailableByName } from '@/Constants/bindings';
export interface moduleProps {
    position: xyz;
    uuid: string;
    side: sides;
    data: itemDataApi,
    category: categoryDataApi;
}

export const toJSON = (data: string | null): xyz | null => {
    if (typeof data === 'string') {
        return JSON.parse(data);
    }
    return null;
};

export const checkColor = (itemHex: string, targetHex: string): boolean => {
    if (targetHex.length)
        return itemHex === targetHex;
    else
        return itemHex === useConfigurationStore().getWardrobeBaseColor.replace('#','');
};

export const convertItem = (item: itemDataApi, type = ''): wardrobeItem => {
    const outData = {
        ...JSON.parse(JSON.stringify(item)),
        name: item.blender_name,
        depth: parseFloat(item.depth),
        width: parseFloat(item.width),
        height: parseFloat(item.height),
        rotation: toJSON(item.rotation),
        offsets: toJSON(item.offsets),
        scale: toJSON(item.scale),
        rodHolderPosition: toJSON(item.rodHolderPosition),
        shelfPosition: toJSON(item.shelfPosition),
        childPosition: toJSON(item.childPosition),
        compatibilityWidth: item.compatibilityWidth,
        compatibilityDepth: item.compatibilityDepth,
        color: item.color.hex,
        type: type,
    };
    if (!outData.offsets)
        delete outData.offsets;
    if (!outData.rotation)
        delete outData.rotation;
    return JSON.parse(JSON.stringify(outData));
};

export const findRail = (width: number | string, hex: string) => {
    const rails = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Рельс'))
        .filter((item: itemDataApi)=>checkColor(item.color.hex, hex));

    let rail;
    if (typeof width === 'string') {
        rail = rails.find((item: itemDataApi)=> item.compatibilityWidth === width);
    }
    if (!rail) {
        rail = rails
        .filter((item: itemDataApi)=>
            parseFloat(item.width)>=(typeof width === 'string'? parseInt(width)/100 : width))
        .sort((item1: itemDataApi, item2: itemDataApi)=>
            parseFloat(item1.width) - parseFloat(item2.width))[0];
    }
    if (!rail) {
        rail = rails[0];
        console.warn('Не найдена требуемый рельс');
    }

    return convertItem(rail);
};
//Соединитель стоек
export const getConnectorRack = () => {
    const hex = useConfigurationStore().getWardrobeBaseColor.replace('#','');
    const connectorRack = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Соединитель стоек'))
        .find((item: itemDataApi)=> {
            return checkColor(item.color?.hex, hex);
        });
    if (!connectorRack) {
        console.warn('Не найден Соединитель стоек');
    }

    return convertItem(connectorRack);
};

export const getRacks = (hex) => {
    const racks = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Стойка'))
        .filter((item: itemDataApi)=>typeof item.blender_name === 'string')
        .filter((item: itemDataApi)=>checkColor(item.color?.hex, hex));
    return racks;
};

export const getRackWithMaxHeight = (hex) => {
    return getRacks(hex)
        .sort((item1: itemDataApi, item2: itemDataApi) =>
            parseFloat(item2.height) - parseFloat(item1.height),
        )[0];
};

export const findRack = (height: number, hex: string) => {
    const racks = getRacks(hex);

    let rackItems = racks
        .filter((item: itemDataApi)=>parseFloat(item.height)>=height);

    if (!rackItems[0]) {
        // console.warn('Не найдена требуемая стойка', $.addConnector);
        $.addConnector = true;
        rackItems = getRackWithMaxHeight(hex);
        return convertItem(rackItems);
    }
    $.addConnector = false;
    return convertItem(rackItems[0]);
};

export const findRod = (width: number) => {
    const rods = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Штанга'))
        .filter((item: itemDataApi)=>typeof item.blender_name === 'string');


    const rodItem = rods
        .find((item: itemDataApi)=> item.compatibilityWidth !== null  && +item.compatibilityWidth === +width);
    if (!rodItem) {
        console.warn('Не найдена требуемая штанга');
        return undefined;
    }
    return convertItem(rodItem, 'rod');
};

export const getRodConnector = () => {
    const rodConnector = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .find((item: itemDataApi)=>item.name.includes('Соединитель штанг'));

    if (!rodConnector) {
        console.warn('Не найден соединитель штанг');
        return null;
    }
    return convertItem(rodConnector, 'rodConnector');
};

export const getShelfBrackets = (depth: number, hex: string, compatibilityDepth?: string | null) => {
    const shelfBrackets = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Кронштейн полки'))
        .filter((item: itemDataApi)=>checkColor(item.color?.hex, hex));

    let shelfBracketItems = [];

    if (compatibilityDepth) {
        shelfBracketItems =
            shelfBrackets.filter((item: itemDataApi)=>item.compatibilityDepth===compatibilityDepth);
    }
    if (!compatibilityDepth || !shelfBracketItems.length) {
        shelfBracketItems =
            shelfBrackets.filter((item: itemDataApi)=>parseFloat(item.depth)>=depth)
                .sort((item1: itemDataApi, item2: itemDataApi)=>
                    parseFloat(item1.depth) - parseFloat(item2.depth));
    }

    if (!shelfBracketItems[0]) {
        console.warn('Не найден требуемый кронштейн полки');
        return convertItem(shelfBrackets[0]);
    }
    return convertItem(shelfBracketItems[0]);
};

export const getRodHolder = (hex: string) => {
    const _rodHolder = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Кронштейн штанги'))
        .find((item: itemDataApi)=>checkColor(item.color?.hex, hex));

    if (!_rodHolder) {
        console.warn('Не найден кронштейн штанги');
        return convertItem(_rodHolder[0]);
    }
    return convertItem(_rodHolder);
};

export const getRodCap = () => {
    const rodCap = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .find((item: itemDataApi)=>item.name.includes('Комплект заглушек штанги'));

    if (!rodCap) {
        console.warn('Не найден комплект заглушек штанги');
    }
    return convertItem(rodCap, 'rodCap');
};

//TODO
export const getPulloutFrame = (width: string | null, hex: string) => {
    // TODO имя Рама выдвижная для корзины
    const pullOutFrames = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Рама выдвижная'))
        .filter((item: itemDataApi)=>checkColor(item.color?.hex, hex));
    const pullOutFrame = pullOutFrames.find((item: itemDataApi)=>item.compatibilityWidth===width);
    if (!pullOutFrame) {
        console.warn('Не найдена выдвижная рама для корзины ' + width + ' и цветом ' + hex);
    }
    return convertItem(pullOutFrame);
};

export const getLdspBracket = (depth: string | null, hex: string) => {
    const ldspBrackets = useStoreData().items
        .filter((item: itemDataApi)=>typeof item.name === 'string')
        .filter((item: itemDataApi)=>item.name.includes('Кронштейны полки ЛДСП'))
        .filter((item: itemDataApi)=>checkColor(item.color?.hex, hex));
    const ldspBracket = ldspBrackets.find((item: itemDataApi)=>item.compatibilityDepth===depth);
    if (!ldspBracket) {
        console.warn('Не найден кронштейн полки с глубиной ' + depth + ' и цветом ' + hex);
    }

    return convertItem(ldspBracket);
};



export const getTemplates = (data: itemDataApi) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let templates: wardrobeTemplates = {};
    if (data.name.includes('Корзина')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            // shelf: shelves[3],
            // rodHolder: rodHolder,
            // rod: rods[1],
            // trouserRack: trouserRack[0],
            // pullOutFrame: pullOutFrames[3],
            pullOutFrame: getPulloutFrame(data.compatibilityWidth, data.color.hex),
            basket: convertItem(data, 'basket'),
            assets: [],
        };
    } else if (data.name.includes('Брючница')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            trouserRack: convertItem(data),
            // pullOutFrame: pullOutFrames[3],
            assets: [],
        };

    } else if (data.name.includes('Обувница')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            shelf: convertItem(data, 'shoeRack'),
            assets: [],
        };
    } else if (data.name.includes('Перфопанель')) {
        templates ={
            panel: convertItem(data),
            assets: [],
        };
    } else if (isHooksPanel(data.name)) {
        templates ={
            panel: convertItem(data),
            assets: [],
        };
    } else if (data.name.includes('Полка ЛДСП')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex);
        const ldspBracket = getLdspBracket(data.compatibilityDepth, data.color.hex);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            shelf: convertItem(data, 'ldsp'),
            assets: [
                ldspBracket,
            ],
        };
    } else if (data.name.includes('Полка металлическая')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            shelf: convertItem(data, 'gridShelf'),
            assets: [],
        };
    } else if (data.name.includes('Полка-корзина')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            shelf: convertItem(data, 'gridShelfBasket'),
            assets: [],
        };
    } else if (data.name.includes('Полка мелкосетчатая')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            shelf: convertItem(data, 'gridShelf'),
            assets: [],
        };
    } else if (data.name.includes('Рама выдвижная')) {
        // TODO

    } else if (data.name.includes('Штанга')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);

        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            rodHolderLeft: getRodHolder(data.color.hex),
            rodHolderRight: getRodHolder(data.color.hex),
            rod: convertItem(data),
            rodCapLeft: rodCaps[0],
            rodCapRight: rodCaps[1],
            assets: [ getRodCap() ],
        };

    } else if (data.name.includes('Полка сетчатая')) {
        const shelfBracket = getShelfBrackets(parseFloat(data.depth), data.color.hex, data.compatibilityDepth);
        templates ={
            shelfBracketLeft: shelfBracket,
            shelfBracketRight: shelfBracket,
            shelf: convertItem(data, 'gridShelf'),
            assets: [],
        };
    }

    return templates;
};

const isHooksPanel = (name: string) => {
    let isPanel = false;
    wallAccessories.forEach((code) => {
        isPanel = isPanel || name.includes(code);
    });
    return isPanel;
};

export const getShelfSet = (data: itemDataApi, uuid: string): moduleItem => {
    const type = data.name.includes('Перфопанель') || isHooksPanel(data.name) ? 'panel':'shelf';
    const item = {
        uuid: uuid,
        type: type,
        templates: getTemplates(data),
        height: parseFloat(data.height),
        width: parseFloat(data.width),
        depth: parseFloat(data.depth),
        color: data.color.hex,
        humanName: data.name,
        compatibilityWidth: data.compatibilityWidth,
        compatibilityDepth: data.compatibilityDepth,
        rodAvailable: isRodAvailableByName(data.name),
    } as moduleItem;

    if (type !== 'shelf') return item;


    const heights = Object.entries(item.templates)
        .filter(([ key, item ])=>!Array.isArray(item))
        .map(([ key, item ]) => item.height);
    item.height = Math.max(...heights);

    if (data.compatibilityWidth) {
        item.width = parseInt(data.compatibilityWidth)/100;
    }

    if (data.compatibilityDepth) {
        item.depth = parseInt(data.compatibilityDepth)/100;
    } else {
        const compatibilityDepthItem = Object.entries(item.templates)
            .find(([ key, item ]) => item.compatibilityDepth);

        if (compatibilityDepthItem) {
            item.depth = parseInt(compatibilityDepthItem[1].compatibilityDepth)/100;
        } else {
            const depths = Object.entries(item.templates).map(([ key, item ]) => item.depth);
            item.depth = Math.max(...depths);
        }
    }

    return item;
};

export const getEmptyUnits = (height: number): Array<'prev'> => {
    const occupiedUnits = Math.ceil(height / rackHoles);
    const units: Array<'prev'> = [];
    units.length = occupiedUnits;
    units.fill('prev');
    return units;
};

export const getChildren = (data: itemDataApi, uuid: string): Array<moduleItem> => {
    const itemChild = getShelfSet(data, uuid);
    return [
        itemChild,
        // ...getEmptyUnits(itemChild.height),
    ];
};

export function getModuleTemplate(shelf: moduleItem) {
    const color = shelf.color.replace('#','');
    // const rail = findRail(shelf.compatibilityWidth || shelf.width, color);
    const rack = findRack(shelf.height, color);
    if (!rack) return null;
    let templates;
    // if (shelf.width > 0.8 && shelf.type !== 'panel') {
    //     templates = [ rack, rack, rack ];
    // } else {
        templates = [ rack, rack ];
    // }
    const newModule: wardrobeModule = {
        uuid: crypto.randomUUID(),
        templates,
        width: (shelf.compatibilityWidth?shelf.compatibilityWidth/100:shelf.width),
        height: rack.height,
        depth: Math.max(shelf.depth, 0.4),
        position: shelf.position,
        railAlign: 'center',
        side: shelf.side,
        color: color,
        // children: [ getShelfSet(data, crypto.randomUUID()) ],
    };

    return newModule;
}

export function createModule({ data, position, uuid, side }: moduleProps): wardrobeModule {
    const rack = findRack(parseFloat(data.height), data.color.hex);
    let templates;
    // if (parseFloat(data.width) > 0.8) {
    //     templates = [ rack, rack, rack ];
    // } else {
        templates = [ rack, rack ];
    // }

    const newModule = {
        uuid: uuid,
        templates,
        width: parseFloat(data.width),
        height: rack?.height,
        depth: Math.max(parseFloat(data.depth), 0.4),
        position: position,
        railAlign: 'center',
        side: side,
        color: data.color.hex.length ? data.color.hex:useConfigurationStore().getWardrobeBaseColor.replace('#',''),
        // children: [ getShelfSet(data, crypto.randomUUID()) ],
    } as wardrobeModule;

    if (data.compatibilityWidth) {
        newModule.width = parseInt(data.compatibilityWidth)/100;
    }

    return newModule;

}
